<template>
	<div class="pages" v-loading="listLoading">
		<div v-for='(item,index) in templateData.TemplateContent.Controls' :key='index'>
			<Digit v-if='item.Property.Control=="Number"' :data-val='item'></Digit>
			<Contact v-if='item.Property.Control=="Condition"' :data-val="item"></Contact>
			<Dates v-if='item.Property.Control=="Date"' :data-val="item"></Dates>
			<Version v-if='item.Property.Control=="Text"' @child-event='getTextVal' :data-val="item"></Version>
			<Money v-if='item.Property.Control=="Money"' :data-val="item"></Money>
			<Tips v-if='item.Property.Control=="Tips"' :data-val="item"></Tips>
			<File v-if='item.Property.Control=="File"' :data-val="item"></File>
			<Table v-if='item.Property.Control=="Table"' @child-event='tableOperation' :data-val='item'
				:template-data='templateData'></Table>
			<Selector v-if='item.Property.Control=="Selector"' @child-event='getSelectorVal' :data-val='item'>
			</Selector>
			<Textarea v-if='item.Property.Control=="Textarea"' :data-val='item'></Textarea>
			<Choose v-if='item.Property.Control=="Contact"' @child-event='clickChoose' :data-val='item'></Choose>
		</div>
		<AnswerTemplate :data-val="QuestionsAndAnswers"></AnswerTemplate>
		<Button class="submit-process" v-on:click='submit' v-bind:loading="formLoading" v-bind:disabled="isDisabled"
			size="large" type="primary"> 提交
		</Button>
	</div>
</template>

<script>
	/**
	 * Version 为Text文本组件
	 */
	import Digit from '../components/Number.vue'
	import Contact from '../components/Contact.vue';
	import Dates from '../components/Date.vue';
	import Version from '../components/Text.vue';
	import Money from '../components/Money.vue';
	import Tips from '../components/Tips.vue';
	import File from '../components/File.vue';
	import Table from '../components/Table.vue';
	import Selector from '../components/Selector.vue';
	import Textarea from '../components/Textarea.vue';
	import Choose from '../components/Choose.vue';
	import wx from 'weixin-js-sdk'
	import stringUtils from "../assets/js/stringUtil.js";
	import AnswerTemplate from "../components/AnswerTemplate.vue";
	import {
		initWxConfig
	} from '../api/jssdk.js';
	import {
		getTemplateInfo,
		submitProcess,
		sendMessage
	} from '@/api/approval'
	import {
		getDepartmentRelationByName,
		getDepartmentRelationById,
		getDepartmentInfo
	} from '@/api/department'
	import {
		getRelation
	} from '@/api/employee'
	import {
		getVirtualNumberBindCount,
		flagExist,
		SaveVirtualNumber,
		CheckedVirtualNumber
	} from '@/api/VirtualNumber.js'
	
	var isSubmit = false;

	var template = {
		TemplateContent: {
			Controls: []
		}
	};
	const sendMessagetTemplate = {
		title: null,
		url: null,
		toUser: [],
		desc: null,
		template: null,
	};
	export default {
		components: {
			Contact,
			Dates,
			Version,
			Money,
			Tips,
			File,
			Table,
			Digit,
			Selector,
			Textarea,
			Choose,
			AnswerTemplate
		},
		data() {
			return {
				templateData: template,
				relationList: null,
				logInfo: null,
				templateId: "",
				spNo: null,
				sendMessageData: Object.assign({}, sendMessagetTemplate),
				formLoading: false,
				listLoading: false,
				flowId: null,
				isDisabled: false,
				QuestionsAndAnswers: {
					IsShow: true,
					datas: [{
							"Question": "下列符合开场话术的是(多选)",
							"Options": [
								"A、xx老师，您好!我是之前带您看过房子的[中原地产/xx商渠/xx地产/xx项目]的xx,可以耽误您一点时间想回访您一下近期还有买房打算吗？",
								"B、客户不反感时，近期我们有一个xx项目，在xxx位置，单价xxx, 不知道您有没有兴趣了解下？",
								"C、xx老师， 您好!您最近有考虑投资商铺没呢",
								"D、xx老师，您好!您最近有考虑商业投资没得，近期我们有一个xx项目 ，在xxx位置，单价xxx，不知道您有没有兴趣了解下",
							],
							"checkList": [],
							// "Ans0wer":[1,2],
							"Answer": ["A", "B"].join(""),
						},
						{
							"Question": "下列符合结束语话术的是(多选)",
							"Options": [
								"A、好的，抱歉打扰您了，祝您生活愉快!",
								"B、要的，不考虑就算了哈!",
								"C、好的，抱歉打扰您了!",
								"D、不好意思可能拔错号了，对不起打扰到您"
							],
							"checkList": [],
							//"Answer":[1,4],
							"Answer": ["A", "D"].join("")
						},
						{
							"Question": "下列词语中，通话坚决不能出现的是(多选)",
							"Options": [
								"A、新房",
								"B、商铺",
								"C、商业投资",
								"D、商业"
							],
							"checkList": [],
							//"Answer":[1,2,3],
							"Answer": ["A", "B", "C"].join("")
						}
					]
				}
			}
		},
		created() {
			initWxConfig(this);
			this.logInfo = this.getLoginUserInfo();
			this.templateId = this.$route.query.templateId;
			this.flowId = this.$route.query.flowId;
			this.getTemplate();
			stringUtils.setAddIsShow(false);
		},
		methods: { //方法
			clickChoose: async function(dataVal, name) {

			},
			getTemplate: async function() {
				this.listLoading = true;
				const that = this;
				var fullName = that.logInfo.fullName;
				var EmpName = that.logInfo.EmpName;
				var DeptName = that.logInfo.DeptName;
				var EmpNo = that.logInfo.EmpNo;
				if (fullName.indexOf("住宅部") === -1 && EmpNo !== "SC20003197") {
					that.Message({
						message: '没有申请权限',
						type: 'error',
						duration: 3000
					});
					this.isDisabled = true;
					return;
				}
				let count;
				await CheckedVirtualNumber(EmpNo).then(res => {
					if(res.ErrCode == 4){
						that.Message({
							message: res.Body,
							type: 'error',
							duration: 3000
						});
						this.isDisabled = true
						return;
					}else{
						getVirtualNumberBindCount(EmpNo).then(res => {
							count = res.Body
							flagExist(EmpNo).then(response => {
								let code = response.ErrCode
								let msg = response.ErrMsg
								if (code != 4) {
									if(count == 2){
										that.Message({
											message: "您无需申请，请前往A+自行扫码绑定虚拟号",
											type: 'error',
											duration: 3000
										});
									}else{
										that.Message({
											message: msg,
											type: 'error',
											duration: 3000
										});
									}
									this.isDisabled = true;
									return;
								}
							})
						})
					}
				})
				await getTemplateInfo(this.templateId).then(async response => {
					var controls = response.Body;
					this.templateData = this.assignControl(controls, this.logInfo);
					//this.templateData = await this.assignControlBySpNo(controls, null, this.flowId);
					this.listLoading = false;
				});

			},
			getTextVal() {},
			getSelectorVal(val, name) {},
			ChangeSelect(options, type) {

			},
			tableOperation(val, type, datas) {
				this.tableoperation(val, type, datas, this);
			},
			submit() {
				let count;
				this.isDisabled = true
				//数据校验
				if (!this.submitValidate(this.templateData.TemplateContent.Controls)) {
					this.isDisabled = false
					return;
				}
				let indexs = []
				this.QuestionsAndAnswers.datas.forEach((item, i) => {
					let list = item.checkList
					list.sort();
					if (list.join("") !== item.Answer) {
						indexs.push(i + 1)
					}
				})
				if (indexs.length !== 0) {
					this.Message({
						message: `${indexs.join()}题 答案错误`,
						type: 'error',
						duration: 3000
					});
					this.isDisabled = false
					return;
				}
				if (isSubmit) {
					this.Message({
						message: '已提交',
						type: 'warning',
						duration: 1000
					});
					return;
				}

				var SummaryList = [];
				var info = {
					SummaryInfo: []
				}
				info.SummaryInfo = [];

				var info = {
					SummaryInfo: []
				}
				info.SummaryInfo = [];
				this.templateData.SummaryList = SummaryList;

				isSubmit = true;
				
				//保存
				SaveVirtualNumber({
					EmpNo: this.logInfo.EmpNo,
					EmpName: this.logInfo.EmpName,
					Department: this.logInfo.DeptName,
					Mobile: this.logInfo.Mobile
				}).then(res => {
					if(res.ErrCode === 0){
						this.Message({
							message: '申请成功',
								type: 'success',
								duration: 3 * 1000
							});
							isSubmit = false;
							setTimeout(() => {
								this.$router.push("/index");
							}, 3000)
					}else if(res.ErrCode === 4){
						isSubmit = false;
						this.isDisabled = false
						this.Message({
							message: res.ErrMsg,
								type: 'error',
								duration: 3 * 1000
							});
					}
				})
				
				//提交
				// submitProcess(this.templateId, this.logInfo.EmpNo, this.spNo, this.templateData, this.flowId).then(
				// 	response => {
				// 		this.Message({
				// 			message: '申请成功',
				// 			type: 'success',
				// 			duration: 3 * 1000
				// 		});
				// 		setTimeout(() => {
				// 			this.$router.push("/index");
				// 		}, 3000)
				// 	}).catch(e => {
				// 	this.isDisabled = true
				// }).finally(() => {
				// 	isSubmit = false;
				// 	this.listLoading = false;
				// });
			}
		}

	}
</script>

<style lang="less">
	.pages {
		padding-bottom: 14px;
	}

	.ivu-select-item {
		white-space: inherit !important;
	}
</style>
